import React, { createContext,useState,useRef } from 'react'
import {Outlet} from 'react-router-dom';
import ComedyHeader from './comedyHeader'
import ComedyFooter from './comedyFooter';
import ScrollRestoration from '../common/onWindowLoadUp';
import ScrollUp from '../common/scrollUp';
import '../../styles/comedy.css'
import '../../styles/common.css'
import RouteTracker from '../common/routeTracker';
export const  DeviceContext = createContext()


const Comedy = ({isMobile}) => {
          
             const [mobile,setMobile] = useState(isMobile)
             const comedyContainerRef =useRef(null)
   
      
  return (
    <div className='comedy-container' ref={comedyContainerRef} >
           <ComedyHeader  isMobile={isMobile} />
             <ScrollRestoration containerRef={comedyContainerRef} />
              <div className='comedy-content'>
                <DeviceContext.Provider value={{mobile,setMobile,containerRef:comedyContainerRef}} >   
                <Outlet />
                </DeviceContext.Provider>
           </div>
          <ComedyFooter /> 
           <ScrollUp containerSelector={'.comedy-container'} /> 
         <RouteTracker />
    </div>
  )
}

export default Comedy;
